import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Mail, HelpCircle, FileText, Shield } from 'lucide-react';
interface FooterModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'soporte' | 'contacto' | 'terminos' | 'privacidad';
}
const modalContent = {
  soporte: {
    icon: HelpCircle,
    title: 'Centro de Soporte',
    content: <div className="space-y-6" data-id="element-238">
        <p className="text-gray-600 leading-relaxed" data-id="element-239">
          Estamos aquí para ayudarte en cada paso de tu transformación
          financiera.
        </p>

        <div className="space-y-4" data-id="element-240">
          <div className="bg-[#f5f1e8] rounded-xl p-6" data-id="element-241">
            <h3 className="font-bold text-[#1e3a5f] mb-3 flex items-center gap-2" data-id="element-242">
              <Mail className="w-5 h-5 text-[#d4a574]" data-id="element-243" />
              Contacto Directo
            </h3>
            <p className="text-gray-700 mb-2" data-id="element-244">
              ¿Tienes dudas sobre el contenido o necesitas ayuda técnica?
            </p>
            <a href="mailto:contactomikioscodigital@gmail.com" className="text-[#d4a574] font-semibold hover:underline break-all" data-id="element-245">
              contactomikioscodigital@gmail.com
            </a>
            <p className="text-sm text-gray-500 mt-2" data-id="element-246">
              Tiempo de respuesta: 24-48 horas hábiles
            </p>
          </div>

          <div className="bg-[#f5f1e8] rounded-xl p-6" data-id="element-247">
            <h3 className="font-bold text-[#1e3a5f] mb-3" data-id="element-248">
              Preguntas Frecuentes
            </h3>
            <ul className="space-y-3 text-gray-700" data-id="element-249">
              <li data-id="element-250">
                <strong data-id="element-251">¿Cómo accedo al contenido?</strong>
                <p className="text-sm text-gray-600 mt-1" data-id="element-252">
                  Recibirás un email inmediato con el enlace de descarga tras tu
                  compra.
                </p>
              </li>
              <li data-id="element-253">
                <strong data-id="element-254">¿Puedo descargar en varios dispositivos?</strong>
                <p className="text-sm text-gray-600 mt-1" data-id="element-255">
                  Sí, puedes descargar y usar el contenido en todos tus
                  dispositivos personales.
                </p>
              </li>
              <li data-id="element-256">
                <strong data-id="element-257">¿Hay actualizaciones?</strong>
                <p className="text-sm text-gray-600 mt-1" data-id="element-258">
                  Sí, recibirás actualizaciones gratuitas del contenido de por
                  vida.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
  },
  contacto: {
    icon: Mail,
    title: 'Contacto',
    content: <div className="space-y-6" data-id="element-259">
        <p className="text-gray-600 leading-relaxed" data-id="element-260">
          Nos encantaría escucharte. Estamos aquí para responder tus preguntas y
          ayudarte en tu camino hacia la libertad financiera.
        </p>

        <div className="space-y-4" data-id="element-261">
          <div className="bg-[#f5f1e8] rounded-xl p-6" data-id="element-262">
            <h3 className="font-bold text-[#1e3a5f] mb-4" data-id="element-263">
              Información de Contacto
            </h3>
            <div className="space-y-3" data-id="element-264">
              <div data-id="element-265">
                <p className="text-sm text-gray-500 mb-1" data-id="element-266">Email Principal</p>
                <a href="mailto:contactomikioscodigital@gmail.com" className="text-[#d4a574] font-semibold hover:underline flex items-center gap-2 break-all" data-id="element-267">
                  <Mail className="w-4 h-4 flex-shrink-0" data-id="element-268" />
                  <span data-id="element-269">contactomikioscodigital@gmail.com</span>
                </a>
              </div>
            </div>
          </div>

          <div className="bg-[#f5f1e8] rounded-xl p-6" data-id="element-270">
            <h3 className="font-bold text-[#1e3a5f] mb-3" data-id="element-271">
              Horario de Atención
            </h3>
            <p className="text-gray-700" data-id="element-272">
              Lunes a Viernes: 9:00 AM - 6:00 PM (Hora del Centro de México)
            </p>
            <p className="text-sm text-gray-500 mt-2" data-id="element-273">
              Respondemos todos los emails dentro de 24-48 horas hábiles.
            </p>
          </div>

          <div className="bg-[#1e3a5f] text-white rounded-xl p-6" data-id="element-274">
            <h3 className="font-bold mb-3" data-id="element-275">Síguenos en Redes Sociales</h3>
            <p className="text-gray-300 text-sm mb-4" data-id="element-276">
              Únete a nuestra comunidad para tips diarios, historias de éxito y
              motivación constante.
            </p>
            <div className="flex gap-3" data-id="element-277">
              <a href="#" className="text-[#d4a574] hover:underline text-sm" data-id="element-278">
                Instagram
              </a>
              <span className="text-gray-500" data-id="element-279">•</span>
              <a href="#" className="text-[#d4a574] hover:underline text-sm" data-id="element-280">
                Facebook
              </a>
              <span className="text-gray-500" data-id="element-281">•</span>
              <a href="#" className="text-[#d4a574] hover:underline text-sm" data-id="element-282">
                YouTube
              </a>
            </div>
          </div>
        </div>
      </div>
  },
  terminos: {
    icon: FileText,
    title: 'Términos y Condiciones',
    content: <div className="space-y-6 text-gray-700" data-id="element-283">
        <p className="text-gray-600 leading-relaxed" data-id="element-284">
          Al adquirir "Finanzas Fáciles para Mujeres", aceptas los siguientes
          términos y condiciones:
        </p>

        <div className="space-y-4" data-id="element-285">
          <section data-id="element-286">
            <h3 className="font-bold text-[#1e3a5f] mb-2" data-id="element-287">
              1. Uso del Contenido
            </h3>
            <p className="text-sm leading-relaxed" data-id="element-288">
              El contenido de este producto digital es para uso personal y no
              comercial. Tienes derecho a descargar y usar el material en tus
              dispositivos personales. Queda prohibida la distribución, reventa,
              o reproducción del contenido sin autorización expresa.
            </p>
          </section>

          <section data-id="element-289">
            <h3 className="font-bold text-[#1e3a5f] mb-2" data-id="element-290">
              2. Propiedad Intelectual
            </h3>
            <p className="text-sm leading-relaxed" data-id="element-291">
              Todo el contenido, incluyendo textos, plantillas, ejercicios y
              diseños, está protegido por derechos de autor. La compra te otorga
              una licencia de uso personal, no la propiedad del material.
            </p>
          </section>

          <section data-id="element-292">
            <h3 className="font-bold text-[#1e3a5f] mb-2" data-id="element-293">
              3. Política de Reembolso
            </h3>
            <p className="text-sm leading-relaxed" data-id="element-294">
              Ofrecemos una garantía de satisfacción de 7 días. Si el producto
              no cumple tus expectativas, puedes solicitar un reembolso completo
              dentro de los primeros 7 días posteriores a la compra, sin
              preguntas.
            </p>
          </section>

          <section data-id="element-295">
            <h3 className="font-bold text-[#1e3a5f] mb-2" data-id="element-296">
              4. Descargo de Responsabilidad
            </h3>
            <p className="text-sm leading-relaxed" data-id="element-297">
              Este producto tiene fines educativos e informativos. No constituye
              asesoría financiera profesional personalizada. Los resultados
              pueden variar según el esfuerzo y circunstancias individuales. No
              garantizamos resultados específicos.
            </p>
          </section>

          <section data-id="element-298">
            <h3 className="font-bold text-[#1e3a5f] mb-2" data-id="element-299">
              5. Actualizaciones
            </h3>
            <p className="text-sm leading-relaxed" data-id="element-300">
              Como cliente, recibirás acceso gratuito a todas las
              actualizaciones futuras del contenido. Te notificaremos por email
              cuando haya nuevo material disponible.
            </p>
          </section>

          <section data-id="element-301">
            <h3 className="font-bold text-[#1e3a5f] mb-2" data-id="element-302">6. Soporte</h3>
            <p className="text-sm leading-relaxed" data-id="element-303">
              Ofrecemos soporte técnico por email para ayudarte con cualquier
              problema de acceso o descarga. El tiempo de respuesta es de 24-48
              horas hábiles.
            </p>
          </section>
        </div>

        <div className="bg-[#f5f1e8] rounded-xl p-4 mt-6" data-id="element-304">
          <p className="text-xs text-gray-600" data-id="element-305">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-MX', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>
        </div>
      </div>
  },
  privacidad: {
    icon: Shield,
    title: 'Política de Privacidad',
    content: <div className="space-y-6 text-gray-700" data-id="element-306">
        <p className="text-gray-600 leading-relaxed" data-id="element-307">
          Tu privacidad es importante para nosotros. Esta política explica cómo
          recopilamos, usamos y protegemos tu información personal.
        </p>

        <div className="space-y-4" data-id="element-308">
          <section data-id="element-309">
            <h3 className="font-bold text-[#1e3a5f] mb-2" data-id="element-310">
              1. Información que Recopilamos
            </h3>
            <p className="text-sm leading-relaxed mb-2" data-id="element-311">
              Recopilamos la siguiente información cuando realizas una compra:
            </p>
            <ul className="text-sm space-y-1 ml-4 list-disc" data-id="element-312">
              <li data-id="element-313">Nombre completo</li>
              <li data-id="element-314">Dirección de correo electrónico</li>
              <li data-id="element-315">
                Información de pago (procesada de forma segura por nuestro
                procesador de pagos)
              </li>
              <li data-id="element-316">Dirección IP y datos de navegación</li>
            </ul>
          </section>

          <section data-id="element-317">
            <h3 className="font-bold text-[#1e3a5f] mb-2" data-id="element-318">
              2. Uso de tu Información
            </h3>
            <p className="text-sm leading-relaxed mb-2" data-id="element-319">
              Utilizamos tu información para:
            </p>
            <ul className="text-sm space-y-1 ml-4 list-disc" data-id="element-320">
              <li data-id="element-321">Procesar tu compra y entregarte el producto digital</li>
              <li data-id="element-322">Enviarte actualizaciones sobre tu pedido</li>
              <li data-id="element-323">Proporcionarte soporte técnico cuando lo solicites</li>
              <li data-id="element-324">
                Enviarte contenido educativo y ofertas (puedes cancelar en
                cualquier momento)
              </li>
              <li data-id="element-325">Mejorar nuestros productos y servicios</li>
            </ul>
          </section>

          <section data-id="element-326">
            <h3 className="font-bold text-[#1e3a5f] mb-2" data-id="element-327">
              3. Protección de Datos
            </h3>
            <p className="text-sm leading-relaxed" data-id="element-328">
              Implementamos medidas de seguridad técnicas y organizativas para
              proteger tu información personal contra acceso no autorizado,
              pérdida o alteración. Usamos encriptación SSL para todas las
              transacciones y almacenamos datos en servidores seguros.
            </p>
          </section>

          <section data-id="element-329">
            <h3 className="font-bold text-[#1e3a5f] mb-2" data-id="element-330">
              4. Compartir Información
            </h3>
            <p className="text-sm leading-relaxed" data-id="element-331">
              No vendemos, alquilamos ni compartimos tu información personal con
              terceros, excepto:
            </p>
            <ul className="text-sm space-y-1 ml-4 list-disc mt-2" data-id="element-332">
              <li data-id="element-333">
                Procesadores de pago necesarios para completar tu transacción
              </li>
              <li data-id="element-334">
                Proveedores de servicios de email para enviarte el producto y
                comunicaciones
              </li>
              <li data-id="element-335">Cuando sea requerido por ley</li>
            </ul>
          </section>

          <section data-id="element-336">
            <h3 className="font-bold text-[#1e3a5f] mb-2" data-id="element-337">5. Cookies</h3>
            <p className="text-sm leading-relaxed" data-id="element-338">
              Utilizamos cookies para mejorar tu experiencia en nuestro sitio
              web, analizar el tráfico y personalizar el contenido. Puedes
              configurar tu navegador para rechazar cookies, aunque esto puede
              afectar algunas funcionalidades.
            </p>
          </section>

          <section data-id="element-339">
            <h3 className="font-bold text-[#1e3a5f] mb-2" data-id="element-340">6. Tus Derechos</h3>
            <p className="text-sm leading-relaxed mb-2" data-id="element-341">Tienes derecho a:</p>
            <ul className="text-sm space-y-1 ml-4 list-disc" data-id="element-342">
              <li data-id="element-343">Acceder a tu información personal</li>
              <li data-id="element-344">Solicitar corrección de datos incorrectos</li>
              <li data-id="element-345">Solicitar la eliminación de tus datos</li>
              <li data-id="element-346">
                Cancelar la suscripción a nuestros emails en cualquier momento
              </li>
              <li data-id="element-347">
                Presentar una queja ante la autoridad de protección de datos
              </li>
            </ul>
          </section>

          <section data-id="element-348">
            <h3 className="font-bold text-[#1e3a5f] mb-2" data-id="element-349">7. Contacto</h3>
            <p className="text-sm leading-relaxed" data-id="element-350">
              Para ejercer tus derechos o si tienes preguntas sobre esta
              política, contáctanos en:{' '}
              <a href="mailto:contactomikioscodigital@gmail.com" className="text-[#d4a574] hover:underline break-all" data-id="element-351">
                contactomikioscodigital@gmail.com
              </a>
            </p>
          </section>
        </div>

        <div className="bg-[#f5f1e8] rounded-xl p-4 mt-6" data-id="element-352">
          <p className="text-xs text-gray-600" data-id="element-353">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-MX', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>
        </div>
      </div>
  }
};
export function FooterModal({
  isOpen,
  onClose,
  type
}: FooterModalProps) {
  const content = modalContent[type];
  const Icon = content.icon;
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  // Close on escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      window.addEventListener('keydown', handleEscape);
    }
    return () => window.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-354">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50" data-id="element-355" />

          {/* Modal */}
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-356">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          type: 'spring',
          duration: 0.5
        }} className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[85vh] overflow-hidden" data-id="element-357">
              {/* Header */}
              <div className="bg-[#1e3a5f] text-white p-6 flex items-center justify-between" data-id="element-358">
                <div className="flex items-center gap-3" data-id="element-359">
                  <div className="w-10 h-10 bg-[#d4a574] rounded-lg flex items-center justify-center" data-id="element-360">
                    <Icon className="w-5 h-5 text-[#1e3a5f]" data-id="element-361" />
                  </div>
                  <h2 className="text-2xl font-serif font-bold" data-id="element-362">
                    {content.title}
                  </h2>
                </div>
                <button onClick={onClose} className="text-gray-300 hover:text-white transition-colors p-2 hover:bg-white/10 rounded-lg" aria-label="Cerrar" data-id="element-363">
                  <X className="w-6 h-6" data-id="element-364" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 overflow-y-auto max-h-[calc(85vh-88px)]" data-id="element-365">
                {content.content}
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}